import { flexRoot, betweenJustified, centerCenter, end, centerJustified } from 'csstips';
import { px } from 'csx';
import React from 'react';
import { style, classes } from 'typestyle';
import { colorGunmetal } from '../../../theme/color';
import { SVGIcon } from '../../svg-icon';
import YoutubeCertified from '../../../static/youtube-certified.png';
import TrustPilot from '../../../static/trustpilot-logo-4stars-color.png';
import { spacing } from '../../../theme/spacing';

const styles = {
  authority: style(flexRoot, centerJustified, end, {
    margin: '0 auto',
    gap: spacing.XSMALL,
  }),
  youtubeLogo: style({
    height: px(12),
  }),
  trustPilotLogo: style({
    height: px(24),
  }),
};

interface AccreditationsProps {
  className?: string;
}

export const Accreditations: React.FC<AccreditationsProps> = ({ className }) => {
  return (
    <div className={classes(styles.authority, className)}>
      <img className={styles.youtubeLogo} src={YoutubeCertified} alt="Lickd is Youtube Certified" loading="lazy" />
      <img
        className={styles.trustPilotLogo}
        src={TrustPilot}
        alt="Lickd has 4 out of 5 stars on Trustpilot"
        loading="lazy"
      />
    </div>
  );
};
